import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Users } from "lucide-react";

export default function AdminCustomers() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      api.get(`/admin/customers${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => { setItems(r.data); setLoading(false); });
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="admin-customers-page">
      <div className="mb-6 flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="eyebrow mb-2">CRM</div>
          <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Customers</h1>
        </div>
        <div className="relative w-full md:w-80">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" strokeWidth={1.75}/>
          <Input data-testid="admin-customer-search" placeholder="Search by name or email…" value={q} onChange={(e) => setQ(e.target.value)} className="h-10 pl-9 rounded-md border-slate-300"/>
        </div>
      </div>

      <div className="border border-slate-200 rounded-md bg-white overflow-hidden">
        {loading ? (
          <div className="p-8 text-slate-400 text-xs font-mono uppercase tracking-widest">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-12 text-center text-slate-500"><Users className="w-8 h-8 mx-auto mb-2 text-slate-300" strokeWidth={1.5}/>No customers found.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200 font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <tr>
                <th className="text-left px-5 py-3">Name</th>
                <th className="text-left px-5 py-3">Email</th>
                <th className="text-left px-5 py-3">Signed up</th>
                <th className="text-right px-5 py-3">Orders</th>
                <th className="text-right px-5 py-3">LTV</th>
              </tr>
            </thead>
            <tbody>
              {items.map((u) => (
                <tr key={u.user_id} className="border-b border-slate-100 last:border-b-0 hover:bg-slate-50">
                  <td className="px-5 py-4">
                    <Link to={`/admin/customers/${u.user_id}`} className="text-slate-900 hover:text-blue-700" data-testid={`admin-customer-${u.user_id}`}>{u.name}</Link>
                  </td>
                  <td className="px-5 py-4 text-slate-600">{u.email}</td>
                  <td className="px-5 py-4 text-slate-500 text-xs">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                  <td className="px-5 py-4 text-right font-mono">{u.orders_count}</td>
                  <td className="px-5 py-4 text-right font-mono text-slate-900">${u.ltv.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
